<ng-container
  *ngIf="
    templateOptions.direction === 'horizontal';
    then horizontal;
    else default
  "
>
</ng-container>

<ng-template #default>
  <div class="form-group">
    <label [ngStyle]="labelStyle">
      {{ (key | translate).labelText }}
      <a
        *ngIf="infoDialogId"
        class="gold cursor-pointer"
        data-toggle="modal"
        [attr.data-target]="'#' + infoDialogId"
        [title]="(key | translate).infoMessage"
      >
        <i class="fi-info"></i>
      </a>
    </label>
    <ng-container
      [ngTemplateOutlet]="showValueText ? normalText : translated"
    ></ng-container>
  </div>
</ng-template>

<ng-template #horizontal>
  <div class="form-group row">
    <div class="col-sm-3">
      <label [ngStyle]="labelStyle">
        {{ (key | translate).labelText }}
        <a
          *ngIf="infoDialogId"
          class="gold cursor-pointer"
          data-toggle="modal"
          [attr.data-target]="'#' + infoDialogId"
          [title]="(key | translate).infoMessage"
        >
          <i class="fi-info"></i>
        </a>
      </label>
    </div>
    <div class="col-sm-9">
      <ng-container
        [ngTemplateOutlet]="showValueText ? normalText : translated"
      ></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #normalText>
  <ng-container
    [ngTemplateOutlet]="displayValue"
    [ngTemplateOutletContext]="{ text: valueText }"
  ></ng-container>
</ng-template>

<ng-template #translated>
  <ng-container
    [ngTemplateOutlet]="displayValue"
    [ngTemplateOutletContext]="{
      text: isArabic ? valueTextAr : valueTextEn
    }"
  ></ng-container>
</ng-template>

<ng-template #displayValue let-text="text">
  <div [ngStyle]="valueStyle" class="detail-text">
    <a *ngIf="valueUrl; else plainText" [href]="valueUrl">
      {{ text }}
    </a>

    <ng-template #plainText>
      {{ text }}
    </ng-template>
  </div>
</ng-template>
